<template>
	<div class="row">
		<div class="col-6">
			<label for="inputDataInicio">Data Inicial</label>
			<div class="input-group">
				<div class="input-group-prepend">
					<span class="input-group-text" id="dataInicio"><i class="fas fa-calendar-alt fa-fw"/></span>
				</div>
				<input type="date" :id="`${id}_inputDataInicio`" name="startDate" ref="startDate" v-model="startDate" class="form-control" aria-label="DataInicio" aria-describedby="dataInicio" :required="required">
			</div>
		</div>
		<div class="col-6">
			<label for="inputDataFim">Data Final</label>
			<div class="input-group">
				<div class="input-group-prepend">
					<span class="input-group-text" id="dataFim"><i class="fas fa-calendar-alt fa-fw"/></span>
				</div>
				<input type="date" :id="`${id}_inputDataFim`" name="endDate" ref="endDate" v-model="endDate" class="form-control" aria-label="DataFim" aria-describedby="dataFim" :required="required">
			</div>
		</div>
	</div>
</template>
<script>
    export default {
        props: {'id': String,
        'autofill': {
            type: String,
            default: 'monthly'
        },
        'required': {
            type: Boolean,
            default: true
        }},
        data () {
			return {
				startDate: moment().format('YYYY-MM-DD'),
				endDate: moment().format('YYYY-MM-DD')
			}
        },
		created() {
			if (this.autofill === 'initialToday'){
				this.startDate = moment().format('YYYY-MM-DDTHH:mm');
				this.endDate =  moment().endOf('month').format('YYYY-MM-DDT00:00');
			}
		},
		mounted() {
			if (this.autofill === 'initialToday'){
				const now = moment().format('YYYY-MM-DD');

				$(this.$refs.startDate).attr('min', now);
				$(this.$refs.endDate).attr('min', now);
			}
		}
    }
</script>
